import BaseApi from './baseApi';
import IRPTQueries from '../models/IRPTQueries';
import IAuthentication from '../models/IAuthentication';
export default class RPTQueriesApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Reports");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetRPTQueries() : Promise<IRPTQueries[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var queries: IRPTQueries[] = [];
            queries = response.data as IRPTQueries[];
            return queries;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveRPTQueries(queries: IRPTQueries) : Promise<string> {
        const json = this.getJsonSave(queries);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateRPTQueries(queries: IRPTQueries) : Promise<boolean> {
        const json = this.getJsonUpdate(queries);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteRPTQueries(queriesId: string) : Promise<boolean> {
        const json = this.getJsonDelete(queriesId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(idQuery: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "RPT_Queries",
            "conditions": [{
                "Item1": "RPT_Queries",
                "Item2": "id",
                "Item3": "=",
                "Item4": idQuery
            }]
        };
        return json;
    }

    private getJsonSave(parameter: IRPTQueries) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "queryName",
                "Item2": parameter.queryName
            }, {
                "Item1": "queryInstruction",
                "Item2": parameter.queryInstruction
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "RPT_Queries"
        };
        return json;
    }

    private getJsonUpdate(parameter: IRPTQueries) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "queryName",
                "Item2": parameter.queryName
            }, {
                "Item1": "queryInstruction",
                "Item2": parameter.queryInstruction
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "RPT_Queries",
            "keyvalue": parameter.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "RPT_Queries",
                "Item2": "id"
            }, {
                "Item1": "RPT_Queries",
                "Item2": "queryName"
            }, {
                "Item1": "RPT_Queries",
                "Item2": "queryInstruction"
            }],
            "tables": [{
                "Item1": "RPT_Queries"
            }],
            "conditions": [{
                "Item1": "RPT_Queries",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }
}
